export function allButLastDigit(value: number) {
  return Math.floor(value / 10);
}
